import { includes } from "lodash";

export const DECIMAL_COMMA = ",";
export const DECIMAL_PERIOD = ".";

export const DECIMAL_SEPARATOR_BY_MARKET = {
  CA: DECIMAL_PERIOD,
  AU: DECIMAL_PERIOD,
  UK: DECIMAL_PERIOD,
  US: DECIMAL_PERIOD,
  SE: DECIMAL_COMMA,
  NB: DECIMAL_COMMA,
  FR: DECIMAL_COMMA,
  FC: DECIMAL_COMMA,
  FB: DECIMAL_COMMA,
  DE: DECIMAL_COMMA
};

export const getDecimalConfig = preferredDecimal => {
  const useComma = preferredDecimal === DECIMAL_COMMA;
  const decimalMark = useComma ? DECIMAL_COMMA : DECIMAL_PERIOD;
  const validFormat = new RegExp(
    useComma ? "(0(,d*)?|([1-9]d*,?d*)|(,d+))" : "(0(.d*)?|([1-9]d*.?d*)|(.d+))"
  );
  const stripRegex = useComma ? /[^0-9,]/g : /[^0-9.]/g;

  return {
    useComma,
    decimalMark,
    validFormat,
    stripRegex
  };
};

const parseMask = (mask = "000000.0000") => {
  const maskData = mask.split(DECIMAL_PERIOD);
  const integerLength = maskData[0].length;
  const decimalLength = maskData.length === 2 ? maskData[1].length : 0;

  return {
    integerLength,
    decimalLength
  };
};

export const getValue = (value, mask, preferredDecimal) => {
  const { validFormat } = getDecimalConfig(preferredDecimal);

  if (!validFormat.test(value)) {
    return null;
  }

  const { decimalLength, integerLength } = parseMask(mask);
  const input = String(value);
  //Auto-detect decimal mark and split on it (regardless of the preferred decimal for the market)
  const decimalMark = includes(input, DECIMAL_COMMA)
    ? DECIMAL_COMMA
    : DECIMAL_PERIOD;
  const parts = input.split(decimalMark);
  const integer = (parts[0] || "0").substr(0, integerLength);
  const decimal = (parts[1] || "")
    .replace(/[^0-9]/g, "")
    .substr(0, decimalLength);

  if (parts.length > 1) {
    return parseFloat(`${integer}.${decimal}`);
  } else {
    return parseFloat(integer);
  }
};

export const getViewValue = (value, mask, preferredDecimal) => {
  const { useComma } = getDecimalConfig(preferredDecimal);
  const maskedValue = getValue(value, mask, preferredDecimal);
  const viewValue = String(maskedValue ?? "");
  if (useComma) {
    return viewValue.replace(DECIMAL_PERIOD, DECIMAL_COMMA);
  } else {
    return viewValue.replace(DECIMAL_COMMA, DECIMAL_PERIOD);
  }
};
